module.exports = __webpack_public_path__ + "img/director-tiao-icon2.8e2edd84.png";